import { Controller } from "@hotwired/stimulus";

interface RemoveFilterEvent extends Event {
  params?: {
    key: string;
  };
}

export default class extends Controller<HTMLFormElement> {
  applyFilter(event: Event) {
    event.preventDefault();

    this.element.requestSubmit();
  }

  resetFilter(event: Event) {
    event.preventDefault();

    const inputs = this.element.querySelectorAll(
      `input:not([name^="q[s]"]), select:not([name^="q[s]"])`
    );
    inputs.forEach((input) => {
      if (
        input instanceof HTMLInputElement ||
        input instanceof HTMLSelectElement
      ) {
        input.disabled = true;
      }
    });

    this.element.requestSubmit();
  }

  removeFilter(event: RemoveFilterEvent) {
    event.preventDefault();

    if (event.params?.key) {
      const inputToRemoveFilters = this.element.querySelectorAll(
        `input[name*="${event.params.key}"], select[name*="${event.params.key}"]`
      );
      inputToRemoveFilters.forEach((input) => {
        if (
          input instanceof HTMLInputElement ||
          input instanceof HTMLSelectElement
        ) {
          input.disabled = true;
        }
      });

      this.element.requestSubmit();
    }
  }
}
